import { useEffect, useState } from "react";
import { loadSavedViews, SAVED_VIEWS_EVENT, SAVED_VIEWS_KEY, SavedPatientView } from "./savedViews";

/** Saved views, kept in sync between the sidebar, the Patients page and other tabs. */
const useSavedPatientViews = (): SavedPatientView[] => {
  const [views, setViews] = useState<SavedPatientView[]>(loadSavedViews);

  useEffect(() => {
    const refresh = () => setViews(loadSavedViews());
    const onStorage = (event: StorageEvent) => {
      if (event.key === SAVED_VIEWS_KEY) refresh();
    };
    window.addEventListener(SAVED_VIEWS_EVENT, refresh);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(SAVED_VIEWS_EVENT, refresh);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return views;
};

export default useSavedPatientViews;
